import { createContext } from 'react';

export type ContentfulContextInterface = {
    globalSettings: {
      loginSignupCtaText?: string;
    },
};

export const ContentfulContext = createContext<ContentfulContextInterface>({
  globalSettings: {
    loginSignupCtaText: null
  },
});

export default ContentfulContext;
